import { motion } from "framer-motion";
import { useRef } from "react";
import { BsTelephoneFill } from "react-icons/bs";
import { FaPaperPlane } from "react-icons/fa";
import { ImLocation } from "react-icons/im";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SectionTitle from "../../components/SectionTitle";
import { fadeIn } from "../../variants";

const Contact = () => {
  const form = useRef();

  // const sendEmail = (e) => {
  //   e.preventDefault();

  //   emailjs
  //     .sendForm(
  //       "service_iyt3qcq",
  //       "template_zxgqz7d",
  //       form.current,
  //       "_2LJ63SKMhK1OIev_"
  //     )
  //     .then(
  //       (result) => {
  //         console.log(result.text);
  //         toast.success(
  //           "Thanks for reaching out. I have received your message and will reply soon!"
  //         );
  //         form.current.reset();
  //       },
  //       (error) => {
  //         console.log(error.text);
  //       }
  //     );
  // };

  const sendEmail = (e) => {
  e.preventDefault();

  // Temporary fallback (Email service disabled)
  toast.info(
  "Sorry! Due to a technical issue, the message could not be sent. Please call or email me directly. Thank you for understanding 🙏",
  {
    position: "bottom-center",
    autoClose: 6000,
    style: {
      width: "430px",
      fontSize: "16px",
    },
  }
);


  form.current.reset();
};

  return (
    <section
      className="section min-h-[80vh] mt-10 lg:mt-28 xl:mt-20"
      id="contact"
    >
      <div className="container mx-auto mb-40">
        <div className="flex flex-col lg:flex-row items-center">
          {/* Contents */}
          <motion.div
            variants={fadeIn("down", 0.3)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: true, amount: 0.3 }}
            className="flex-1"
          >
            {/* Title */}
            <SectionTitle normalText={"Contact"} coloredText={"Me"} />
            {/* Subtitle */}
            <h3 className="mb-10 text-[20px] md:text-[25px] font-secondary font-semibold uppercase leading-[1]">
              Let's Work Together!
            </h3>
            {/* Address */}
            <div className="flex items-center gap-2 mb-4">
              <span className="text-xl text-white bg-black/30 rounded-full p-3">
                <ImLocation />
              </span>
              <p className="text-white/80">
                <span className="text-xl font-semibold text-white">
                  Address:
                </span>{" "}
                Dhaka, Bangladesh.
              </p>
            </div>
            <div className="flex items-center gap-2 mb-4">
              <span className="text-xl text-white bg-black/30 rounded-full p-3">
                <BsTelephoneFill />
              </span>
              <p className="text-white/80">
                <span className="text-xl font-semibold text-white">Phone:</span>{" "}
                +880 1868518963
              </p>
            </div>
            <div className="flex items-center gap-2 mb-4">
              <span className="text-xl text-white bg-black/30 rounded-full p-3">
                <FaPaperPlane />
              </span>
              <p className="text-white/80">
                <span className="text-xl font-semibold text-white">Email:</span>{" "}
                mdyasinarafathasib@gmail.com
              </p>
            </div>
          </motion.div>

          {/* Form */}
          <motion.form
            ref={form}
            onSubmit={sendEmail}
            variants={fadeIn("up", 0.3)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: true, amount: 0.3 }}
            className="flex-1"
          >
            <input
              className="bg-transparent border-b ps-2 mt-1 pt-6 pb-2 outline-none w-full placeholder:text-white focus:border-accent transition-all"
              type="text"
              name="user_name"
              placeholder="Your Full Name"
              required
            />
            <input
              className="bg-transparent border-b ps-2 mt-1 pt-6 pb-2 outline-none w-full placeholder:text-white focus:border-accent transition-all"
              type="email"
              name="user_email"
              placeholder="Your Email"
              required
            />
            <input
              className="bg-transparent border-b ps-2 mt-1 pt-6 pb-2 outline-none w-full placeholder:text-white focus:border-accent transition-all"
              type="number"
              name="number"
              placeholder="Your Mobile Number"
              required
            />
            <input
              className="bg-transparent border-b ps-2 mt-1 pt-6 pb-2 outline-none w-full placeholder:text-white focus:border-accent transition-all"
              type="text"
              name="subject"
              placeholder="Subject"
              required
            />
            <textarea
              className="bg-transparent border-b ps-2 mt-1 outline-none w-full placeholder:text-white focus:border-accent transition-all resize-none pt-10"
              cols="20"
              rows="4"
              name="message"
              placeholder="Type Your Message"
            />
            {/* button submit */}
            <input
              type="submit"
              value="Send Message"
              className="btn rounded-sm px-5 py-3 cursor-pointer"
            />
          </motion.form>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};

export default Contact;
